const currencies = [
  'AED',
  'AFA',
  'ALL',
  'AMD',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZM',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BTN',
  'BWP',
  'BYN',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLP',
  'CNH',
  'CNY',
  'COP',
  'CRC',
  'CUP',
  'CVE',
  'CYP',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'ECS',
  'EEK',
  'EGP',
  'ETB',
  'EUR',
  'FIM',
  'FJD',
  'FKP',
  'GBP',
  'GEL',
  'GHC',
  'GHS',
  'GIP',
  'GMD',
  'GNF',
  'GRD',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'IEP',
  'ILS',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  'KPW',
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LRD',
  'LSL',
  'LTL',
  'LVL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MGF',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRO',
  'MTL',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MXP',
  'MYR',
  'MZM',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NLG',
  'NOK',
  'NPR',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PTE',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SDD',
  'SDP',
  'SEK',
  'SGD',
  'SHP',
  'SIT',
  'SKK',
  'SLL',
  'SOS',
  'SRG',
  'STD',
  'SVC',
  'SYP',
  'SZL',
  'THB',
  'TJS',
  'TND',
  'TOP',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VEF',
  'VES',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XAG',
  'XAU',
  'XCD',
  'XEU',
  'XOF',
  'XPD',
  'XPT',
  'YER',
  'ZAR',
  'ZMW',
  'ZWD',
]
export default currencies